import {DateTime} from "luxon";

interface IDateFormats {
  readonly dateShortWith2Digits: Intl.DateTimeFormatOptions;
  readonly dateTimeShortWith2Digits: Intl.DateTimeFormatOptions;
}

export const DateFormats: IDateFormats = {
  get dateShortWith2Digits(): Intl.DateTimeFormatOptions {
    return {
      ...(DateTime.DATE_SHORT),
      day: "2-digit",
      month: "2-digit",
    };
  },
  get dateTimeShortWith2Digits(): Intl.DateTimeFormatOptions {
    return {
      ...(DateTime.DATETIME_SHORT),
      day: "2-digit",
      month: "2-digit",
    };
  },
};
